import { useEffect, useState } from "react";
import Layout from "../../custom/Layout";
import VirtualTable from "../../custom/VirtualTable";
import { ChangeEvent, IForkliftCheck } from "../../../globals/interfaces";
import apiClient from "../../../apiClient";
import { useAppContext } from "../../../context";
import styled from "styled-components";
import { Input } from "reactstrap";
import useStationInfo from "../../reporting/breakdownProgress/useStationInfo";
import { print } from "../../../utils";
import GenerateReport from "./GenerateReport";
import moment from "moment";

export default function EquipmentCheck () {

    const { user } = useAppContext();
    const { s_unit } = user;
    const stationInfo = useStationInfo();
    const [createdAt, setCreatedAt] = useState(moment().format('YYYY-MM-DD'));
    const [data, setData] = useState<Array<IForkliftCheck>>([]);
    const [selectedReport, setSelectedReport] = useState<IForkliftCheck>();

    useEffect(() => {
        const getData = async () => {
            try {
                const res = await apiClient.get(`/forklift-check?createdAt=${createdAt}&unit=${s_unit}`);
                setData(res.data);
            } catch (err) {
                alert(err);
            }
        }
        if (createdAt && s_unit) {
            getData();
        }
    }, [createdAt, s_unit]);

    const handlePrint = (report: IForkliftCheck) => {
        print(<GenerateReport item={report} stationInfo={stationInfo} />);
    } 

    return (
        <Layout>
            <FlexContainer>
                <h1>Equipment Check</h1>
                <Input type={'date'} value={createdAt} onChange={(e: ChangeEvent) => setCreatedAt(e.target.value)} />
            </FlexContainer>
            <VirtualTable 
                data={data}
                mapping={[{
                    name: 'Created by',
                    value: 'createdBy',
                    email: true
                }, {
                    name: 'Created at',
                    value: 'createdAt',
                    datetime: true,
                    utc: true
                }, {
                    name: 'Forklift Type',
                    value: 'forkliftType'
                }, {
                    name: 'Forklift Id',
                    value: 'forkliftId'
                }, {
                    name: 'Check Passed',
                    value: 'checkPassed',
                    boolean: true
                }]}
                numRows={10}
                handleClick={handlePrint}
            />
        </Layout>
    );
}

const FlexContainer = styled.div`
    display: flex;
    gap: 25px;
    align-items: baseline;

    & input {
        width: 150px;
    }
`;